// Angular
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Services
import { AuthenticationService } from 'app/auth/service';
import * as service from 'app/center/service/index';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _centerService: service.Center
  ) {}

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this._authenticationService.currentUserValue;

    if (currentUser) {
      // check if route is restricted by role
      if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
        // role not authorised so redirect to not-authorized page
        this._router.navigate(['/pages/miscellaneous/not-authorized']);
        return false;
      }

      // check if the route needs an active center
      if (
        route.data.cip &&
        (this._centerService.currentCIP === null ||
          this._centerService.currentCenterAdvanced === null ||
          this._centerService.currentCenterBasic === null)
      ) {
        this._centerService.cleanCurrentCenter();
        this._router.navigate(['/pages/app/centers']);
        return false;
      }

      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this._router.navigate(['/authentication/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
